import useAppStore from "@/stores/app";
import {useSessionStore} from "@/stores/session";
import {useChatwootStore} from "@/stores/chatwoot";
import {useQrStore} from "@/stores/qr";
import {useOptionStore} from "@/stores/option";

export default function useStore() {
  return {
    app: useAppStore(),
    session: useSessionStore(),
    chatwoot: useChatwootStore(),
    option: useOptionStore(),
    qr: useQrStore()
  };
}
